import { useContext } from "preact/hooks";
import rootContext from "../context";
import { Dispatch } from "../types";

const useDispatch = (): Dispatch => {
    return useContext(rootContext).dispatch;
};

export default useDispatch;
